import React from 'react';
import { ServicesProvider } from '../context/ServicesContext';

export const AppProvider = ({ children }) => {
    return (
        <ServicesProvider>
            {children}
        </ServicesProvider>
    );
};

export default AppProvider;
